export default class Tema {
    constructor() {
        this.idTema = '';
        this.idEspecialidade = '';
        this.especialidade = {
            idEspecialidade: ''
        };
        this.nome = '';
        this.status = '';
    }
  }